import React from "react";
import {
  AddMissingProductModalState,
  OccupantSelectionItem,
} from "../../../../types/IMultiLocationQuoteMobile";
import "./OccupantPickerModal.css";

interface OccupantPickerModalProps {
  modalState: AddMissingProductModalState | null;
  selectedOccupantKeys: string[];
  submitting: boolean;
  onClose: () => void;
  onToggleOccupant: (key: string) => void;
  onSubmit: () => void;
}

const OccupantPickerModal: React.FC<OccupantPickerModalProps> = ({
  modalState,
  selectedOccupantKeys,
  submitting,
  onClose,
  onToggleOccupant,
  onSubmit,
}) => {
  if (!modalState) {
    return null;
  }

  const selectionCount = selectedOccupantKeys.length;

  return (
    <div
      className="occupant-picker-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Escape" || e.key === "Enter") {
          onClose();
        }
      }}
    >
      <div
        id="occupant-picker-sheet"
        className="occupant-picker-sheet"
        role="dialog"
        aria-modal="true"
        aria-label="Select occupants for missing product"
      >
        <div className="occupant-picker-handle" />

        <div className="occupant-picker-header">
          <div className="occupant-picker-title">
            Which Occupants Buy This Product?
          </div>
          <button
            id="occupant-picker-close-button"
            type="button"
            className="occupant-picker-close"
            onClick={onClose}
            disabled={submitting}
            aria-label="Close occupant picker"
          >
            ×
          </button>
        </div>

        <div className="occupant-picker-subtitle">
          Select one or more occupants at this location
        </div>

        <div className="occupant-picker-list">
          {modalState.occupants.map((occupantItem: OccupantSelectionItem) => {
            const isSelected = selectedOccupantKeys.includes(occupantItem.key);
            const isDisabled = submitting || !!occupantItem.disabled;

            return (
              <button
                id={`occupant-picker-option-${occupantItem.key}`}
                key={occupantItem.key}
                type="button"
                className={`occupant-picker-option ${
                  isSelected ? "occupant-picker-option-selected" : ""
                }`}
                onClick={() => onToggleOccupant(occupantItem.key)}
                disabled={isDisabled}
              >
                <span
                  className={`occupant-picker-check ${
                    isSelected ? "occupant-picker-check-selected" : ""
                  }`}
                >
                  {isSelected ? "✓" : ""}
                </span>
                <span className="occupant-picker-option-label">
                  {occupantItem.label}
                </span>
              </button>
            );
          })}
        </div>

        <div className="occupant-picker-footer">
          <button
            id="occupant-picker-cancel-button"
            type="button"
            className="occupant-picker-cancel"
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            id="occupant-picker-done-button"
            type="button"
            className="occupant-picker-done"
            onClick={onSubmit}
            disabled={!selectionCount || submitting}
          >
            {submitting ? "Adding..." : "Done"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OccupantPickerModal;
